// ============================================================
// index.tsx — 應用程式進入點
// ============================================================

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// 全域基礎樣式（注入至 document head）
const globalStyle = document.createElement('style');
globalStyle.textContent = `
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  body {
    background: #0a0a1a;
    font-family: 'Noto Sans TC', -apple-system, BlinkMacSystemFont, sans-serif;
    -webkit-font-smoothing: antialiased;
  }
  ::-webkit-scrollbar       { width: 6px; height: 6px; }
  ::-webkit-scrollbar-track { background: #1a1a2e; }
  ::-webkit-scrollbar-thumb { background: #333; border-radius: 3px; }
  ::-webkit-scrollbar-thumb:hover { background: #555; }

  /* 載入動畫 */
  .loading-spinner {
    width: 36px; height: 36px;
    border: 3px solid #2a2a3e;
    border-top-color: #00AAFF;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }
  @keyframes spin { to { transform: rotate(360deg); } }

  /* 錄製閃爍點 */
  .recording-badge {
    position: absolute; top: 12px; left: 12px;
    background: rgba(0,0,0,0.7);
    border: 1px solid #FF4444;
    border-radius: 20px;
    padding: 4px 12px;
    color: #FF4444;
    font-size: 12px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .recording-dot {
    width: 8px; height: 8px;
    background: #FF4444;
    border-radius: 50%;
    animation: pulse 1s ease-in-out infinite;
  }
  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50%       { opacity: 0.3; }
  }
`;
document.head.appendChild(globalStyle);

// 掛載 React 應用
const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
